var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop",
              attrs: {
                isShowFollow: false,
                title: _vm.title,
                isShowClose: false,
              },
              on: { open: _vm.opened, close: _vm.closed },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "content" },
              [
                _c("el-form", { ref: "form" }, [
                  _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      {
                        staticClass: "item-box-title box",
                        staticStyle: { margin: "0" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "new-h-opt",
                            staticStyle: { padding: "0" },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn-plain-primary-new",
                                attrs: {
                                  plain: "",
                                  type: "default",
                                  icon: "el-icon-circle-check",
                                  size: "mini",
                                },
                                on: { click: _vm.handleSubmit },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("home.agreement")) +
                                    "\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "btn-plain-danger-new",
                                attrs: {
                                  plain: "",
                                  type: "default",
                                  icon: "el-icon-circle-close",
                                  size: "mini",
                                },
                                on: { click: _vm.handleCancel },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("home.back")) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.registerTermContent
                      ? _c(
                          "div",
                          { staticClass: "item-content" },
                          [
                            _c("h3", { staticClass: "term-title" }, [
                              _vm._v(_vm._s(_vm.$t("home.registerAgreement"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: {
                                    value: _vm.registerTermContent,
                                    type: "textarea",
                                    readonly: "",
                                    autosize: { maxRows: 15 },
                                    resize: "none",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.bookingTermContent
                      ? _c(
                          "div",
                          { staticClass: "item-content" },
                          [
                            _c("h3", { staticClass: "term-title" }, [
                              _vm._v(_vm._s(_vm.$t("home.bookingAgreement"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: {
                                    value: _vm.bookingTermContent,
                                    type: "textarea",
                                    readonly: "",
                                    autosize: { maxRows: 15 },
                                    resize: "none",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }